import React, { useState, useEffect } from "react";
import infoIcon from "../../assets/icons/Info-Circle.svg";
import {useDispatch, useSelector} from "react-redux";
import {setWcagGuidelinesPayload} from "../../store/slice/setupSlice";

const WcagGuidelines = ({ allGuidelinesWcag, selectedVersions, setSelectedVersions, excelData, isGuidelineRender }) => {
  const dispatch = useDispatch();
  const { wcagGuidelinesPayload } = useSelector((state) => { return state.setupDetails });
  const { selectedProject } = useSelector((state) => { return state.bugDetails })
  const [selectAllA, setSelectAllA] = useState(true); // Flag to track whether all items in List A are selected
  const [selectAllAA, setSelectAllAA] = useState(true); // Flag to track whether all items in List AA are selected
  const [listAData, setListAData] = useState([]);
  const [listAAData, setListAAData] = useState([]);
  const [filterAData, setFilterAData] = useState([]);
  const [filterAAData, setFilterAAData] = useState([]);


  useEffect(() => {
    if(allGuidelinesWcag && Object.keys(allGuidelinesWcag).length &&  selectedVersions.length){
      renderData();
    }
  }, [isGuidelineRender]);  

  const renderData = () => {
    
    const featureListLength = excelData?.flat()
   if (featureListLength?.length) {
     const listA = allGuidelinesWcag?.A?.filter((item) =>
     selectedVersions?.includes(item.version))  ;
     console.log("listA <>", listA)

     const listAA = allGuidelinesWcag?.AA?.filter((item) =>
     selectedVersions?.includes(item.version))  ;
     console.log("listAA <>", listAA)

     setListAData(listA);
     setListAAData(listAA);

     let filterA = listA?.filter((item) => item.selected);
     setFilterAData(filterA);

     let filterAA = listAA?.filter((item) => item.selected);
     setFilterAAData(filterAA);
    
    const selectAllSelectA = (listA?.length === filterA?.length)
    const selectAllSelectAA = (listAA?.length === filterAA?.length);
    if(selectAllSelectA) {
      setSelectAllA(true)
    }else{
      setSelectAllA(false)
    }
    if(selectAllSelectAA) {
      setSelectAllAA(true)
    }else{
      setSelectAllAA(false)
    }
    
     dispatch(
      setWcagGuidelinesPayload({
        ...wcagGuidelinesPayload,
        listADataPayload: filterA,
        listAADataPayload: filterAA,
      })
    );
   } else {
     const listA = allGuidelinesWcag?.A?.filter((item) =>
       selectedVersions?.includes(item.version)
     )?.map((item) => ({ ...item, selected: true })); // Initialize all items as selected for List A

     const listAA = allGuidelinesWcag?.AA?.filter((item) =>
       selectedVersions?.includes(item.version)
     )?.map((item) => ({ ...item, selected: true })); // Initialize all items as selected for List AA

     setListAData(listA);
     setListAAData(listAA);
     // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listADataPayload: listA, listAADataPayload: listAA}))
     let filterA = listA?.filter((item) => item.selected);
     setFilterAData(filterA);

     let filterAA = listAA?.filter((item) => item.selected);
     setFilterAAData(filterAA);

     dispatch(
       setWcagGuidelinesPayload({
         ...wcagGuidelinesPayload,
         listADataPayload: filterA,
         listAADataPayload: filterAA,
       })
     );
   }

  };

  const handleVersionCheckboxChange = (e) => {
    const version = e.target.value;
    if (selectedVersions?.includes(version)) {
      let selectVersion = selectedVersions?.filter((v) => v !== version);
      setSelectedVersions(selectVersion);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload: selectVersion}))
      const listA = allGuidelinesWcag?.A?.filter((item) =>
        selectVersion?.includes(item.version)
      )?.map((item) => ({ ...item, selected: false }));

      const listAA = allGuidelinesWcag?.AA?.filter((item) =>
        selectVersion?.includes(item.version)
      ).map((item) => ({ ...item, selected: false }));

    //   const listA = allGuidelinesWcag?.A?.filter((item) =>
    //   selectedVersions?.includes(item.version)
    // )?.map((item) => ({ ...item, selected: true }));

      setListAData(listA);
      setListAAData(listAA);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload: selectVersion, listADataPayload: listA, listAADataPayload: listAA}))
      setFilterAData([]);
      setFilterAAData([]);
      setSelectAllA(false);
      setSelectAllAA(false);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload: selectVersion, selectAllAPayload: false, selectAllAAPayload: false, listADataPayload: listA, listAADataPayload: listAA}))
      dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload: selectVersion, selectAllAPayload: false, selectAllAAPayload: false, listADataPayload: [], listAADataPayload: []}))


    } else {
      let versionSelect = [...selectedVersions, version];
      setSelectedVersions(versionSelect);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload:versionSelect}))
      const listA = allGuidelinesWcag?.A?.filter((item) =>
        versionSelect?.includes(item.version)
      ).map((item) => ({ ...item, selected: false }));
      const listAA = allGuidelinesWcag?.AA?.filter((item) =>
        versionSelect?.includes(item.version)
      ).map((item) => ({ ...item, selected: false }));
      setListAData(listA);
      setListAAData(listAA);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listADataPayload: listA, listAADataPayload: listAA}))
      setFilterAData([]);
      setFilterAAData([]);
      setSelectAllA(false);
      setSelectAllAA(false);
      // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload:versionSelect, selectAllAPayload: false, selectAllAAPayload: false, listADataPayload: listA, listAADataPayload: listAA}))
      dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectedVersionsPayload:versionSelect, selectAllAPayload: false, selectAllAAPayload: false, listADataPayload: [], listAADataPayload: []}))

    }
  };

  const handleSelectAllA = () => {
    const updatedListAData = listAData?.map((item) => ({
      ...item,
      selected: !selectAllA,
    }));
    setListAData(updatedListAData);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listADataPayload: updatedListAData}))

    setSelectAllA(!selectAllA);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAPayload: !selectAllA , listADataPayload: updatedListAData}))
    let filterA = updatedListAData?.filter((item) => item.selected);
    setFilterAData(filterA);
    dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAPayload: !selectAllA , listADataPayload: filterA}))

  };

  const handleSelectAllAA = () => {
    const updatedListAAData = listAAData?.map((item) => ({
      ...item,
      selected: !selectAllAA,
    }));
    setListAAData(updatedListAAData);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listAADataPayload: updatedListAAData}))

    setSelectAllAA(!selectAllAA);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAAPayload: !selectAllAA, listAADataPayload: updatedListAAData}))

    let filterAA = updatedListAAData?.filter((item) => item.selected);
    setFilterAData(filterAA);
    dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAAPayload: !selectAllAA, listAADataPayload: filterAA}))

  };

  const handleItemCheckboxChangeA = (id) => {
    const updatedListAData = listAData?.map((item) =>
      item.id === id ? { ...item, selected: !item.selected } : item
    );
    setListAData(updatedListAData);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listADataPayload: updatedListAData}))

    let filterA = updatedListAData?.filter((item) => item.selected);
    setFilterAData(filterA);
    const allItemsSelectedA = updatedListAData.every((item) => item.selected);
    setSelectAllA(allItemsSelectedA);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAPayload: allItemsSelectedA, listADataPayload: updatedListAData}))
    dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAPayload: allItemsSelectedA, listADataPayload: filterA}))

  };

  const handleItemCheckboxChangeAA = (id) => {
    const updatedListAAData = listAAData?.map((item) =>
      item.id === id ? { ...item, selected: !item.selected } : item
    );
    setListAAData(updatedListAAData);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, listAADataPayload: updatedListAAData}))

    let filterAA = updatedListAAData?.filter((item) => item.selected);
    setFilterAAData(filterAA);
    const allItemsSelectedAA = updatedListAAData?.every(
      (item) => item.selected
    );
    setSelectAllAA(allItemsSelectedAA);
    // dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAAPayload: allItemsSelectedAA, listAADataPayload: updatedListAAData}))
    dispatch(setWcagGuidelinesPayload({...wcagGuidelinesPayload, selectAllAAPayload: allItemsSelectedAA, listAADataPayload: filterAA}))

  };

  return (
    <>
      <div className="right-panel">
        <div className="icons">
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="text">WCAG Type</span>
            <img
              src={infoIcon}
              alt="infoIcon"
              style={{ marginLeft: "7px" }}
              draggable={false}
            ></img>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span className="text">WCAG Guideline</span>
            {["2.0", "2.1", "2.2", "3.0"]?.map((version) => (
              <div
                key={version}
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <input
                  type="checkbox"
                  value={version}
                  checked={selectedVersions?.includes(version)}
                  onChange={handleVersionCheckboxChange}
                  disabled={version === "3.0"}
                />
                <label>{version}</label>
              </div>
            ))}
          </div>
        </div>
        <div className="rightPanelWrapper">
          <div className="rightPane-partion">
            <div className="title-div">
              <h3 className="textTitle">WCAG - A</h3>
            </div>

            <div className="option-div">
              
              {listAData?.length ? (
                <div style={{ margin: "5px", display:"flex", alignItems:"center" }}>
                  <input
                    type="checkbox"
                    checked={selectAllA}
                    onChange={handleSelectAllA}
                  />
                  <label>Select All</label>
                </div>
              ) : (
                ""
              )}

              {listAData?.map((item) => (
                <div key={item.id} style={{ margin: "5px", display:"flex", alignItems:"center" }}>
                  <input
                    type="checkbox"
                    checked={item.selected}
                    onChange={() => handleItemCheckboxChangeA(item.id)}
                  />
                  <label>{item.guideline}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="rightPane-partion">
            <div className="title-div">
              <h3 className="textTitle">WCAG - AA</h3>
            </div>
            <div className="option-div">
              {/* <div
                className="checkboxdiv"
                style={{ display: "flex", flexDirection: "column" }}
              >
                
              </div> */}
              {listAData?.length ? (
                <div style={{ margin: "5px", display:"flex", alignItems:"center" }}>
                  <input
                    type="checkbox"
                    checked={selectAllAA}
                    onChange={handleSelectAllAA}
                  />
                  <label>Select All</label>
                </div>
              ) : (
                ""
              )}

              {listAAData?.map((item) => (
                <div key={item.id} style={{ margin: "5px", display:"flex", alignItems:"center" }}>
                  <input
                    type="checkbox"
                    checked={item.selected}
                    onChange={() => handleItemCheckboxChangeAA(item.id)}
                  />
                  <label>{item.guideline}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WcagGuidelines;
